import React, { useCallback, useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import FloatingActionButton from 'components/Luxkit/Button/FloatingActionButton'
import LineLayersIcon from 'components/Luxkit/Icons/line/LineLayersIcon'
import LineAngleUpIcon from 'components/Luxkit/Icons/line/LineAngleUpIcon'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import useToggle from 'hooks/useToggle'
import { useScreenSizeUp } from 'hooks/useScreenSize'
import ModalContext from 'contexts/ModalContext'
import Modal from 'components/Luxkit/Modal/Modal'
import DropdownSheet from 'components/Luxkit/Dropdown/Sheet/DropdownSheet'
import MapLayersOptions from './MapLayersOptions'

const Container = styled.div`
  z-index: 5;
  position: absolute;
  bottom: ${rem(24)};
  left: ${rem(24)};
`

const DropUpContainer = styled(CSSBreakpoint)`
  display: flex;
`

function MapLayersButton() {
  const buttonRef = React.useRef<HTMLButtonElement>(null)

  const { value: isDropdownOpen, toggle: toggleDropdown, off: closeDropdown } = useToggle()

  const isDesktop = useScreenSizeUp('desktop')

  const showModal = useContext(ModalContext)

  const openLayersModal = useCallback(() => {
    showModal(<Modal title="Map layers">
      <MapLayersOptions />
    </Modal>)
  }, [showModal])

  return (
    <Container>
      <FloatingActionButton
        kind="primary"
        variant="ghost"
        startIcon={<LineLayersIcon />}
        ref={buttonRef}
        onClick={isDesktop ? toggleDropdown : openLayersModal}
      >
        <Group direction="horizontal" gap={8} verticalAlign="center">
          <div>Layers</div>
          <DropUpContainer min="desktop">
            <LineAngleUpIcon />
          </DropUpContainer>
        </Group>
      </FloatingActionButton>

      <DropdownSheet
        size="M"
        open={isDropdownOpen}
        placement="top-start"
        onClose={closeDropdown}
        anchorRef={buttonRef}
        triggerRef={buttonRef}
      >
        <MapLayersOptions />
      </DropdownSheet>
    </Container>
  )
}

export default MapLayersButton
